import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import OurStory from './components/OurStory';
import VisionMission from './components/VisionMission';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <AboutHero />
        <OurStory />
        <VisionMission />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;